type IndexFactory = {
  changeType: string;
  isin: string;
  orderEntryDate: number;
  orderId: number;
  orderSequenceNumber: number;
  price: number;
  type: number;
  uniqueKey: string;
  volume: number;
  count: number;
};

type ParentFactory = {
  orderDisplayedQuantity: number;
  orderEntryDate: number;
  orderSequenceNumber: number;
  uniqueKey: string;
  orderPriorityDateTime: string;
  uniqId: string;
};

export function indexFactory(data) {
  const {
    uniqueKey,
    orderSequenceNumber,
    orderEntryDate,
    volume,
    orderPriorityDateTime,
    uniqId,
  } = data;

  return {
    uniqueKey,
    orderDisplayedQuantity: volume,
    orderSequenceNumber,
    orderEntryDate,
    uniqId,
    orderPriorityDateTime,
  };
}

export function parentFactory(data: IndexFactory, index: ParentFactory) {
  const { price, volume, count } = data;

  return {
    count,
    price,
    volume,
    depthModels: [index],
  };
}
